import { Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface BookingSheetBannerProps {
  /** `view` = read-only closed booking; `edit` = editing an existing booking. */
  mode: "view" | "edit";
  /** Display job id, shown in the edit copy ("Editing booking J000123"). */
  jobLabel?: string;
  className?: string;
}

/**
 * Full-width status bar atop the Booking Sheet / Summary, telling the user what state the sheet is in:
 *  - **view** — silver-gray, "This booking is closed and is now view-only".
 *  - **edit** — info-blue, "Editing booking {id}" so it's obvious which job is being changed.
 * `sticky top-0` pins it to the top of its scroll container (the aside / slide-in / main column).
 */
export const BookingSheetBanner = ({ mode, jobLabel, className }: BookingSheetBannerProps) => (
  <div className={clsx("sticky top-0 z-20 py-1.5 text-center", mode === "edit" ? "bg-info" : "bg-neutral-silver-gray", className)}>
    <Typography variant="action" className="text-white">
      {mode === "edit" ? `Editing booking ${jobLabel ?? ""}`.trim() : "This booking is closed and is now view-only"}
    </Typography>
  </div>
);
